import { Routes } from '@angular/router';
import { ProblemComponent } from './problem/problem.component';
import { AuthGuard } from '../../guards/auth.guard';
import { ProblemListComponent } from './problem-list/problem-list.component';
import { solutionRoutes } from './solution/solution.routes';
import { ProblemManagementComponent } from './problem-management/problem-management.component';

export const problemRoutes: Routes = [
  {
    path: 'problems',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {}
    },
    children: [
      {
        path: '',
        component: ProblemListComponent,
        data: {
          type: 'create',
          breadcrumb: {
            bcType: 'Display',
            action: 'List',
            value: 'Problems',
            type: 'Problem'
          }
        }
      },
      {
        path: 'create',
        component: ProblemComponent,
        data: {
          type: 'create',
          breadcrumb: {
            bcType: 'Display',
            action: 'Create',
            value: 'Problems',
            type: 'Problem'
          }

        }
      },
      {
        path: ':problemId',
        data: {
          breadcrumb: {
            bcType: 'LookUp',
            value: 'problemId',
            type: 'Problem'
          }
        },
        children: [
          {
            path: 'edit',
            component: ProblemComponent,
            data: {
              type: 'edit',
              breadcrumb: {
                bcType: 'Display',
                action: 'Edit'
              }
            }
          },
          {
            path: 'manage',
            component: ProblemManagementComponent,
            data: {
              breadcrumb: {
                bcType: 'Display',
                action: 'Manage',
              }
            }
          },
          ...solutionRoutes
        ]
      }
    ]
  },
];
